import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import PROVIDER_CONFIG from "./provider_config";

class Hcpi extends Component {
  render() {
    return <Menu {...PROVIDER_CONFIG} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    messages: {
      ...state.intl.messages.containers.features.hcpi,
      components: {
        result: state.intl.messages.components.painIndex.result,
      },
    },
    hcpi: state.reducers.hcpi,
  };
};

export default connect(mapStateToProps)(Hcpi);
